// extracted by mini-css-extract-plugin
export default {"fs":"_8d1992683b dd1fb82af5"};